$.fn.DynamicText = function() {
  let self = this

  const d = new Date();
  let day = d.getDay();

  if ($('body').hasClass('language-fr')) {
    var days = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  } else {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  }

  var text = self.attr('data-dynamic');
  text = text.replace("%week_day%", days[d.getDay()]);

  self.html(text);

  self.closest('.--dynamic-text').addClass('--ready')

  return function() {
    return self
  }()
};
